// @flow

// Libs
import _get from 'lodash/get'

// Effect Managers
import { take, put, select, fork, call, cancel } from 'redux-saga/effects'

// Sagas
import { centerMapToDefaultLocation } from './watchCenterMapDefault'

// Controllers
import assetsCtrl from 'fc-ctrl-assets'

// Utils
import traverse from 'fc-utils/traverse'

// Turf
import turfBbox from '@turf/bbox'

// Selectors
import getAssetObject from 'hfty-assets/src/selectors/getAssetObject'

// Actions
import { setUserStateBbox } from 'hfty-map/src/actions'

// Constants
import { CENTER_MAP_TO_FIELD } from '../constants'
import { PROP_SHAPE } from 'fc-model-assets'
import { PRESELECTED_JOB_SET } from 'hfty-map-dom/src/constants'
import {
  PROP_SHAPE_DATA,
  PROP_FEATURES,
} from 'fc-model-shapes'

// Local util
const getShape = traverse([PROP_SHAPE, PROP_SHAPE_DATA])

export default function *watchCenterMapToField (): Generator<*, *, *> {
  while (true) {
    const { fieldId } = yield take([CENTER_MAP_TO_FIELD, PRESELECTED_JOB_SET])

    yield fork(handleFieldCentering, { fieldId })
  }
}

export function *handleFieldCentering ({fieldId}: { fieldId: number }): Generator<*, *, *> {
  const selectedField = yield select(getAssetObject(fieldId))
  const shape = getShape(selectedField)

  if (_get(shape, `[${PROP_FEATURES}].length`) > 0) {
    yield fork(centerMapToField, shape)
  } else {
    const centerToDefault = yield fork(centerMapToDefaultLocation)

    yield fork(watchReceiveAssets, { fieldId, centerToDefault })
  }
}

function *centerMapToField (shape: Object): Generator<*, *, *> {
  const map = window._m
  const [minX, minY, maxX, maxY] = turfBbox(shape)

  yield put(setUserStateBbox([[minY, minX], [maxY, maxX]]))

  if (map) {
    map.fitBounds([[minY, minX], [maxY, maxX]])
  }
}

function *watchReceiveAssets (
  {
    fieldId,
    centerToDefault,
    }: {
    fieldId: number,
    centerToDefault: Object,
  }): Generator<*, *, *> {
  let shape = null

  while (!shape) {
    yield take(assetsCtrl.actionTypes.receive())

    const selectedField = yield select(getAssetObject(fieldId))
    shape = getShape(selectedField)

    if (_get(shape, `[${PROP_FEATURES}].length`) > 0) {
      yield cancel(centerToDefault)
      yield call(centerMapToField, shape)
    }
  }
}
